<template>
    <!-- <v-app-bar
        class="header-section pl-0"
        dark
        :color="$vuetify.theme.dark ? 'black' : 'white'"
        fixed
        app
        hide-on-scroll
        scroll-off-screen
        height="48"
        :extension-height="$breakpoint.smAndDown ? 55 : 40"
        :scroll-threshold="105"
        flat
    > -->

    <v-app-bar
        class="header-section pl-0 pr-0"
        dark
        :color="$vuetify.theme.dark ? 'black' : 'white'"
        :fixed="false"
        dense
        :height="$breakpoint.smAndDown ? 54 : $auth.loggedIn ? 57 : 68"
        max-height="84"
        :extension-height="$breakpoint.smAndDown ? 50 : 55"
        :scroll-threshold="105"
        flat
    >
        <!-- <v-container class="mx-auto py-0 my-0"> -->
        <v-row
            no-gutters
            align="center"
            class="header-top"
            :class="!$breakpoint.smAndDown && !$auth.loggedIn ? 'pt-2' : ''"
        >
            <!-- Logo -->
            <v-sheet class="d-flex align-center br-0 header-margin div-tilt">
                <v-img
                    id="v-step-0"
                    :src="`${CDN_IMG_URL}/menu.png`"
                    :lazy-src="`${CDN_IMG_URL}/menu.png`"
                    :max-width="$breakpoint.xsOnly ? 18 : 24"
                    class="ml-3 mr-2 cursor-pointer"
                    :class="{
                        'mt-4': $breakpoint.mdAndUp,
                        'cursor-pointer':
                            version &&
                            version.projectCode &&
                            version.projectCode !== 'fps',
                        'cursor-pointer-fps':
                            version &&
                            version.projectCode &&
                            version.projectCode === 'fps'
                    }"
                    alt="menu icon"
                    @click="drawer1 = !drawer1"
                ></v-img>
                <router-link to="/">
                    <v-img
                        :src="`${CDN_IMG_URL}/website-logo.webp`"
                        :lazy-src="`${CDN_IMG_URL}/website-logo.webp`"
                        :width="$breakpoint.xsOnly ? 80 : 130"
                        :height="$breakpoint.xsOnly ? 40 : 50"
                        contain
                        :aspect-ratio="
                            $vuetify.breakpoint.smAndDown ? 1.5 : 1.67
                        "
                        alt="Logo"
                    ></v-img>
                    <!-- class="pre_logo" -->
                </router-link>
            </v-sheet>
            <!-- <v-card color="primary py-1 pl-3 pr-7 div-tilt" ripple tile flat to="/">
                <v-img
                :src="getLogo()"
                width="60"
                contain
                aspect-ratio="1.48"
                ></v-img>
            </v-card> -->
            <!-- <div
                v-if="
                    $breakpoint.smAndUp &&
                    domainType &&
                    domainType !== 'SuperWin'
                "
                class="text-center mr-2"
            >
                <template v-if="$breakpoint.mdAndUp">
                    <v-btn
                        :href="newsLink"
                        target="_blank"
                        x-small
                        class="header-btns fill-bg"
                        color="#0000"
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-img
                            contain
                            :src="`https://${imageDomain}/images/index/news.svg`"
                            height="14"
                            width="20"
                            aspect-ratio="1"
                        ></v-img>
                        <span> {{ $t("header.news") }} </span>
                    </v-btn>
                </template>
            </div> -->

            <div v-if="$breakpoint.smAndUp" class="text-center mr-2">
                <template v-if="$breakpoint.smAndUp">
                    <v-btn
                        x-small
                        class="header-btns fill-bg"
                        color="#0000"
                        v-bind="attrs"
                        v-on="on"
                        @click="reload"
                    >
                        <v-img
                            contain
                            :src="`https://${imageDomain}/images/index/reload.svg`"
                            height="14"
                            width="20"
                            aspect-ratio="1"
                        ></v-img>
                        <span> {{ $t("header.refresh") }} </span>
                    </v-btn>
                </template>
            </div>

            <div v-if="$breakpoint.smAndUp" class="text-center mr-2">
                <template v-if="$breakpoint.smAndUp">
                    <v-btn
                        x-small
                        href="/blog"
                        class="header-btns fill-bg"
                        color="#0000"
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-img
                            contain
                            :src="`https://${imageDomain}/images/index/news.svg`"
                            height="14"
                            width="20"
                            aspect-ratio="1"
                        ></v-img>
                        <span> {{ $t("header.blogs") }} </span>
                    </v-btn>
                </template>
            </div>

            <v-spacer></v-spacer>
            <v-autocomplete
                v-if="$auth.loggedIn && $breakpoint.lgAndUp"
                ref="search"
                v-model="selected"
                class="mx-4 search-width"
                clearable
                hide-details
                :items="items"
                :loading="loading"
                :search-input.sync="search"
                label="Search for a Sports, Games or Teams"
                item-text="name"
                item-value="_id"
                hide-no-data
                prepend-inner-icon="mdi-magnify"
                :light="!$vuetify.theme.dark"
                solo-inverted
                :class="
                    userBalanceData.balance >= walletBalLimit
                        ? 'hide-search'
                        : ''
                "
            >
                <template #item="{ item }">
                    <v-list-item-icon>
                        <v-icon>{{ item.eventType.name | getIcon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title
                            v-text="item.name"
                        ></v-list-item-title>
                    </v-list-item-content>
                </template>
            </v-autocomplete>
            <span
                class="login form"
                :class="{
                    'before-loggin':
                        !$auth.loggedIn &&
                        version &&
                        version.projectCode &&
                        version.projectCode !== 'fps',
                    'before-loggin-fps':
                        !$auth.loggedIn &&
                        version &&
                        version.projectCode &&
                        version.projectCode === 'fps'
                }"
            >
                <v-form
                    ref="loginForm"
                    v-model="valid"
                    class="d-flex login-form"
                    lazy-validation
                    @submit.prevent="validate"
                >
                    <div v-if="!$auth.loggedIn && $breakpoint.mdAndUp">
                        <div class="d-flex align-center">
                            <!-- <vue-country-code
                    class="black--text mr-2 mb-3"
                    :preferred-countries="['in', 'ae', 'us']"
                    style="height: 32px"
                    @onSelect="onSelect"
                    >
                    </vue-country-code> -->
                            <switch-locale
                                v-if="$breakpoint.lgAndUp"
                                class="mr-2 mt-n3"
                            ></switch-locale>
                            <country-code
                                v-if="
                                    $breakpoint.mdAndUp &&
                                    version &&
                                    version.projectCode &&
                                    version.projectCode !== 'fps'
                                "
                                v-model="form.countryCode"
                                class="mr-1 mt-n3"
                                :readonly="BDcheck"
                            />

                            <v-text-field
                                v-if="$breakpoint.mdAndUp"
                                v-model.trim="form.userName"
                                :label="
                                    version &&
                                    version.projectCode &&
                                    version.projectCode !== 'fps'
                                        ? $t('header.email')
                                        : $t('header.username')
                                "
                                type="text"
                                :prefix="
                                    version && version.projectCode != 'bd'
                                        ? ''
                                        : '0'
                                "
                                required
                                single-line
                                dense
                                :rules="
                                    version &&
                                    version.projectCode &&
                                    version.projectCode !== 'fps'
                                        ? rules.userName
                                        : rules.fpsUserName
                                "
                                class="form-input input-width mr-2"
                                onkeypress="return !/[`~!# \$%^&*()_+\-=\[\]{};':\\|,<>\/?]+/.test(event.key)"
                                onkeydown='return !/["]+/.test(event.key)'
                            ></v-text-field>
                        </div>
                        <div
                            v-if="$breakpoint.mdAndUp"
                            class="text-right caption mt-n2 mr-2 error_message"
                        >
                            <div class="custom-checkbox">
                                <input
                                    id="rememberMe"
                                    v-model="form.checked"
                                    type="checkbox"
                                />
                                <label
                                    for="rememberMe"
                                    class="header-label primary--text"
                                    >{{ $t("header.remember") }}</label
                                >
                            </div>
                        </div>
                    </div>
                    <div v-if="!$auth.loggedIn && $breakpoint.mdAndUp">
                        <div class="login-password">
                            <v-text-field
                                v-if="$breakpoint.mdAndUp"
                                v-model="form.password"
                                :append-icon="
                                    showPassword ? 'mdi-eye-off' : 'mdi-eye'
                                "
                                :type="showPassword ? 'text' : 'password'"
                                :placeholder="$t('header.password')"
                                required
                                single-line
                                dense
                                :rules="rules.password"
                                class="input-width mr-1"
                                @click:append="showPassword = !showPassword"
                            ></v-text-field>
                            <div
                                v-if="
                                    $breakpoint.mdAndUp &&
                                    version &&
                                    version.projectCode &&
                                    version.projectCode !== 'fps'
                                "
                                class="text-right caption mt-n2 mr-2 error_message"
                            >
                                <nuxt-link
                                    v-if="$breakpoint.mdAndUp"
                                    hreflang="en"
                                    to="/forgot-password"
                                    class="text-decoration-none"
                                >
                                    {{ $t("header.forgot") }}?
                                </nuxt-link>
                            </div>
                        </div>
                    </div>
                    <v-btn
                        v-if="!$auth.loggedIn && $breakpoint.mdAndUp"
                        :loading="loginLoading"
                        :large="$breakpoint.smAndUp"
                        color="primary"
                        rounded="rounded"
                        class="mr-2 loginBtn primary-boxshadow font-weight-bold"
                        type="submit"
                    >
                        <span class="white--text">{{
                            $t("header.login")
                        }}</span>
                    </v-btn>

                    <v-btn
                        v-if="!$auth.loggedIn && $breakpoint.smAndDown"
                        :small="$breakpoint.xsOnly"
                        :to="localePath('/login')"
                        :large="$breakpoint.mdAndUp"
                        color="primary"
                        rounded="rounded"
                        class="mr-1 login-btn primary-boxshadow font-weight-bold"
                        type="submit"
                        :loading="loginLoading"
                    >
                        <span class="white--text">{{
                            $t("header.login")
                        }}</span>
                    </v-btn>
                    <!-- :to="localePath('/register')" -->
                    <v-btn
                        v-if="
                            !$auth.loggedIn &&
                            version &&
                            version.projectCode &&
                            (version.projectCode === 'bd-new' ||
                                version.projectCode === 'gb') &&
                            getWhatsappData &&
                            getWhatsappData.isRegisterBtnOnOff
                        "
                        :small="$breakpoint.xsOnly"
                        :to="
                            getWhatsappData.linkPage
                                ? getWhatsappData.registerBtnLink
                                : ''
                        "
                        :href="
                            !getWhatsappData.linkPage
                                ? getWhatsappData.registerBtnLink
                                : ''
                        "
                        :target="!getWhatsappData.linkPage ? '_blank' : ''"
                        depressed
                        :large="$breakpoint.mdAndUp"
                        :color="domainUrl ? 'success' : 'superBlue'"
                        rounded="rounded"
                        class="mr-2 login-btn font-weight-bold"
                        dark
                    >
                        <span class="">{{
                            $t("section_promotion.join_now_button")
                        }}</span>
                    </v-btn>
                </v-form>
            </span>
            <switch-locale
                v-if="$auth.loggedIn && $breakpoint.lgAndUp"
                class="mx-2 d-inlineBlock"
            ></switch-locale>
            <span v-if="$auth.loggedIn" class="">
                <!-- langauage Dropdown  -->
                <!-- <span
                    :class="
                        userBalanceData.balance >= walletBalLimit
                            ? 'hide-search'
                            : ''
                    "
                >
                    <search-modal
                        v-if="$breakpoint.mdAndDown"
                        class="search-one"
                    />
                </span> -->
                <v-btn
                    v-if="$breakpoint.mdAndUp"
                    :x-small="$breakpoint.xsOnly"
                    class="mr-1"
                    :class="$breakpoint.xsOnly ? 'custom-xs-height' : ''"
                    color="primary"
                    rounded
                    outlined
                    to="/bets"
                >
                    <span
                        class="text-capitalize"
                        :class="{
                            'white--text': $vuetify.theme.dark,
                            'black--text': !$vuetify.theme.dark
                        }"
                        >Open Bets</span
                    >
                </v-btn>

                <v-btn
                    v-if="depositWhatsappLink"
                    :small="$breakpoint.xsOnly"
                    rounded
                    outlined
                    color="success"
                    :href="depositWhatsappLink"
                    :target="'_blank'"
                    :class="$breakpoint.xsOnly ? '' : 'mr-1'"
                >
                    <img
                        :lazy-src="`${CDN_IMG_URL}/Deposit_Now_Icon.svg`"
                        :src="`${CDN_IMG_URL}/Deposit_Now_Icon.svg`"
                        alt="Deposit icon"
                        class="deposite_icon"
                        :width="$breakpoint.smAndDown ? '16' : '18'"
                    />
                    <span
                        class="text-capitalize deposit_text"
                        :class="{
                            'white--text': $vuetify.theme.dark,
                            'black--text': !$vuetify.theme.dark
                        }"
                    >
                        Deposit
                    </span>
                    <span
                        v-if="$breakpoint.smAndUp"
                        class="text-capitalize ml-1 deposit_now_text"
                        :class="{
                            'white--text': $vuetify.theme.dark,
                            'black--text': !$vuetify.theme.dark
                        }"
                    >
                        Deposit Now
                    </span>
                </v-btn>
                <v-btn
                    v-else-if="
                        version &&
                        version.projectCode &&
                        version.projectCode !== 'fps'
                    "
                    :small="$breakpoint.xsOnly"
                    rounded
                    outlined
                    :color="domainUrl ? 'success' : 'primary'"
                    :to="
                        getWhatsappData && getWhatsappData.isDepositBtnOn
                            ? '/wallet/deposit'
                            : ''
                    "
                    :href="
                        getWhatsappData && getWhatsappData.isDepositBtnOn
                            ? ''
                            : goToWhatsapp()
                    "
                    :target="
                        getWhatsappData && !getWhatsappData.isDepositBtnOn
                            ? '_blank'
                            : ''
                    "
                    :class="$breakpoint.xsOnly ? '' : 'mr-1'"
                >
                    <img
                        :lazy-src="`${CDN_IMG_URL}/Deposit_Now_Icon.svg`"
                        :src="`${CDN_IMG_URL}/Deposit_Now_Icon.svg`"
                        alt="Deposit icon"
                        class="deposite_icon"
                        :width="$breakpoint.smAndDown ? '16' : '18'"
                    />
                    <span
                        class="text-capitalize deposit_text"
                        :class="{
                            'white--text': $vuetify.theme.dark,
                            'black--text': !$vuetify.theme.dark
                        }"
                    >
                        Deposit
                    </span>
                    <span
                        v-if="$breakpoint.smAndUp"
                        class="text-capitalize ml-1 deposit_now_text"
                        :class="{
                            'white--text': $vuetify.theme.dark,
                            'black--text': !$vuetify.theme.dark
                        }"
                    >
                        Deposit Now
                    </span>
                </v-btn>

                <v-btn
                    :x-small="$breakpoint.xsOnly"
                    :class="$breakpoint.xsOnly ? 'custom-xs-height' : 'mr-1'"
                    :color="domainUrl ? 'primary' : 'superBlue'"
                    rounded
                    outlined
                    to="/wallet"
                >
                    <img
                        :lazy-src="`${CDN_IMG_URL}/wallet.svg`"
                        :src="`${CDN_IMG_URL}/wallet.svg`"
                        alt="wallet icon"
                        class="mr-1"
                        width="14"
                    />
                    <span
                        v-if="version.projectCode !== 'bd-new'"
                        :class="{
                            'white--text': $vuetify.theme.dark,
                            'black--text': !$vuetify.theme.dark
                        }"
                        class="user-balance"
                    >
                        <span v-if="version.projectCode != 'bd-new'"
                            >&#8377;</span
                        ><span v-else>&#2547;</span
                        >{{ userBalanceData.balance | currencyFormat(0) }}
                    </span>
                    <span
                        v-else
                        :class="{
                            'white--text': $vuetify.theme.dark,
                            'black--text': !$vuetify.theme.dark
                        }"
                        class="user-balance"
                    >
                        &#2547;{{ userBalanceData.balance | currencyFormat(0) }}
                    </span>
                </v-btn>

                <!-- <v-btn class="mr-1" to="/my-markets" x-small fab color="primary">
                <v-icon size="14px" color="white">
                mdi-account-star
                </v-icon>
            </v-btn> -->

                <v-btn
                    :small="$breakpoint.xsOnly"
                    rounded
                    class="mr-1"
                    outlined
                    color="px-2 primary"
                    @click="drawer = !drawer"
                >
                    <img
                        :src="require('@/assets/images/profile.svg')"
                        alt="profile icon"
                        class=""
                        width="10"
                    />
                    <span
                        v-if="$breakpoint.smAndUp"
                        class="text-capitalize ml-1"
                        :class="{
                            'white--text': $vuetify.theme.dark,
                            'black--text': !$vuetify.theme.dark
                        }"
                    >
                        Profile
                        <!-- <span
                v-if="
                    $route.name !== 'casino-live-casino' &&
                    $route.name !== 'casino-category-id'
                "
                >
                {{
                    userBalanceData.balance
                    | currencyFormat(2)
                }}
                </span> -->
                        <!-- <span
                v-if="
                    $route.name === 'casino-live-casino' ||
                    $route.name === 'casino-category-id'
                "
                >MENU
                </span> -->

                        <!-- <span v-if="(this.$route.params.category = !'')">MENU</span> -->
                    </span>
                </v-btn>
            </span>
        </v-row>
        <!-- </v-container> -->
        <!-- Sub-header -->
        <template #extension>
            <v-tabs
                v-model="headerTabs"
                class="menu-tabs"
                :color="$vuetify.theme.dark ? 'white' : 'black'"
                :hide-slider="activeBar"
                :show-arrows="$breakpoint.smAndDown"
                grow
                centered
                :icons-and-text="$breakpoint.smAndDown"
            >
                <!-- :height="$breakpoint.smAndDown ? 80 : 75" -->
                <!-- <v-tabs-slider color="primary"></v-tabs-slider> -->
                <!-- <div class="px-0 py-0"> -->
                <div v-if="!$breakpoint.smAndDown" class="fill-height mt-0">
                    <div class="py-0 d-flex fill-height align-center">
                        <div
                            v-if="!$breakpoint.smAndDown"
                            class="d-flex align-center game-nav"
                        >
                            <div
                                v-for="tab in tabs.items.filter(
                                    (t) => !t.hidden
                                )"
                                :key="tab.text"
                                class="d-flex align-center game-nav menu-nav"
                            >
                                <v-tab
                                    v-if="tab.src !== 'fundlist'"
                                    :to="tab.link"
                                    class="caption caption-mobile py-2 px-2 mx-2"
                                >
                                    <v-img
                                        contain
                                        :src="
                                            require(`@/assets/images/menu/${tab.src}.webp`)
                                        "
                                        height="20"
                                        width="24"
                                        class="rounded-t-lg justify-content-center mr-2"
                                        aspect-ratio="1"
                                    ></v-img>
                                    <span>
                                        {{ $t(tab.text) }}
                                    </span>
                                </v-tab>
                                <v-tab
                                    v-else-if="
                                        tab.src == 'fundlist' &&
                                        (!$auth.user || $auth.user.fundist)
                                    "
                                    :to="tab.link"
                                    class="caption caption-mobile py-2 px-2 mx-2"
                                >
                                    <v-img
                                        contain
                                        :src="
                                            require(`@/assets/images/menu/${tab.src}.webp`)
                                        "
                                        height="20"
                                        width="24"
                                        class="rounded-t-lg justify-content-center mr-2"
                                        aspect-ratio="1"
                                    ></v-img>
                                    <span>
                                        {{ $t(tab.text) }}
                                    </span>
                                </v-tab>
                            </div>
                            <div
                                v-if="!$breakpoint.smAndDown"
                                class="d-none game-nav"
                            >
                                <v-tab
                                    v-for="tab in tabs.mobileItems"
                                    :key="tab.text"
                                    :to="tab.link"
                                    class="caption caption-mobile"
                                    :class="{
                                        ' px-2 ml-3 mr-1': $breakpoint.mdAndUp,
                                        'pa-0 ma-0': !$breakpoint.mdAndUp
                                    }"
                                >
                                    <v-img
                                        contain
                                        :src="
                                            require(`@/assets/images/menu/${tab.src}.webp`)
                                        "
                                        height="20"
                                        width="24"
                                        class="rounded-t-lg justify-content-center"
                                        aspect-ratio="1"
                                    ></v-img>
                                    {{ $t(tab.text) }}
                                </v-tab>
                            </div>
                        </div>
                    </div>
                </div>
                <v-row v-if="$breakpoint.smAndDown">
                    <v-col
                        cols="12"
                        sm="12"
                        class="d-flex pl-0 py-0 align-center game-nav"
                    >
                        <v-tab
                            v-for="tab in tabs.mobileItems"
                            :key="tab.text"
                            :to="tab.link"
                            class="caption caption-mobile px-0 py-0 pt-1"
                            :class="{
                                'border-right-none':
                                    tab.text === 'menu.sportsbook'
                            }"
                        >
                            <v-img
                                contain
                                :src="
                                    require(`@/assets/images/menu/${tab.src}.webp`)
                                "
                                height="20"
                                width="24"
                                class="justify-content-center"
                                aspect-ratio="1"
                            ></v-img>
                            {{ $t(tab.text) }}
                        </v-tab>
                        <!-- <v-tab
                            class="text-center d-flex flex-column text-decoration-none mobile-menu-blocks px-0 election-animate"
                            @click="megaMenuDrawer = !megaMenuDrawer"
                        >
                            <v-img
                                contain
                                :src="require(`@/assets/images/menu/more.webp`)"
                                alt="More"
                                height="22"
                                aspect-ratio="1"
                                width="24"
                                class="more"
                            ></v-img
                            ><span color="primary" style="font-size: 0.7rem"
                                >More</span
                            >
                        </v-tab> -->
                    </v-col>
                </v-row>
                <!-- </div> -->
            </v-tabs>
            <v-dialog
                v-if="$auth.loggedIn"
                v-model="showMaintenanceModal"
                persistent
                max-width="400"
            >
                <v-card cols="1" class="pa-0 text-left">
                    <v-card-title class="maintenanceModal">
                        Site is under maintenance! Please try again later.
                    </v-card-title>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            dark
                            color="green"
                            depressed
                            tile
                            @click="changeShowMaintenanceModel(false)"
                        >
                            Ok
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
    </v-app-bar>
</template>

<script>
/* eslint-disable */

/* eslint-disable no-console */
import { mapState } from "vuex"
import { upperFirst, remove } from "lodash"
import constants from "@/constant"
import SearchModal from "@/components/SearchModal"
import debounce from "lodash/debounce"
import CountryCode from "@/components/fairplay/countryCode"
import service from "../../../services/apiService"
import socket from "~/plugins/socket.client"
import socket1 from "~/plugins/newSocket.client.js"
import encryptor from "~/plugins/encryption.js"
import SwitchLocale from "@/components/fairplay/switchLocales"
import { showHrAndGhr } from "~/constant"

export default {
    name: "HeaderBar",
    components: { SearchModal, CountryCode, SwitchLocale },
    data() {
        return {
            domainUrl: process.env.THEME_BASIC === "true" ? 1 : 0,
            imageDomain: process.env.IMGIX_IMAGE_DOMAIN,
            domainType: process.env.APP_TITLE,
            newsLink: process.env.NEWS_PORTAL,
            domain: process.env.DOMAIN_NAME,
            environment: process.env.fairplayEnvironment,
            walletBalLimit: constants.walletBalanceLimit,
            setUp: process.env.setUp,
            captcha: "",
            path: "",
            loginLoading: false,
            // socket1: io(process.env.userAdminUrl, { reconnection: false }),
            userId: "",
            headerTabs: null,
            // title: process.env.THEME_SHORT_TITLE,
            selected: null,
            items: [],
            search: null,
            BDcheck: false,
            tabs: {
                settings: {
                    grow: true
                },
                mobileItems: [
                    {
                        icon: "mdi-play-circle",
                        src: "Inplay",
                        text: "menu.inplay",
                        status: true,
                        link: "/"
                    },
                    {
                        icon: "iconpe-sportsbook",
                        src: "Sportsbook",
                        text: "menu.sportsbook",
                        status: true,
                        link: "/sportsbook"
                    }
                    // {
                    //     icon: "iconpe-election",
                    //     src: "Election",
                    //     text: "election",
                    //     status: true,
                    //     link: "/sportsbook/Election"
                    // },
                    // {
                    //     icon: "mdi-crown",
                    //     src: "fantasybookicon",
                    //     text: "menu.fantasybook",
                    //     status: true,
                    //     link: "/fantasybook"
                    // }
                    // {
                    //     icon: "mdi-crown",
                    //     src: "Premium-Notebook",
                    //     text: "menu.premium_sportbook",
                    //     status: true,
                    //     link: "/premium-sportsbook"
                    // }
                    // {
                    //   icon: 'iconpe-live-casino',
                    //   src: 'live-casino',
                    //   text: 'Casino',
                    //   status: true,
                    //   link: '/casino'
                    // },
                    // {
                    //     icon: "iconpe-live-casino",
                    //     src: "Live-Casino",
                    //     text: "menu.live_casino",
                    //     status: true,
                    //     link: "/casino"
                    // },
                    // {
                    //     icon: "iconpe-live-cards",
                    //     src: "Live-Card",
                    //     text: "menu.live_card",
                    //     status: true,
                    //     link: "/live-cards"
                    // },
                    // {
                    //     icon: "iconpe-slot",
                    //     src: "Slot-Games",
                    //     text: "menu.slot_games",
                    //     status: true,
                    //     link: "/casino-slots"
                    // }
                ],
                items: [
                    {
                        icon: "mdi-play-circle",
                        src: "Inplay",
                        text: "menu.inplay",
                        status: true,
                        link: "/"
                    },
                    {
                        icon: "iconpe-cricket",
                        src: "Cricket",
                        text: "menu.cricket",
                        status: true,
                        link: "/sportsbook/Cricket"
                    },
                    {
                        icon: "mdi-soccer",
                        src: "Soccer",
                        text: "menu.soccer",
                        status: true,
                        link: "/sportsbook/Soccer"
                    },
                    {
                        icon: "iconpe-tennis",
                        src: "Tennis",
                        text: "menu.tennis",
                        status: true,
                        link: "/sportsbook/Tennis"
                    },
                    {
                        src: "horse",
                        icon: "iconpe-horse-racing",
                        text: "menu.horse_racing",
                        status: true,
                        link: "/sportsbook/horse-racing",
                        hidden: !showHrAndGhr
                    },
                    {
                        src: "greyhound",
                        icon: "iconpe-greyhound-racing",
                        text: "menu.greyhound_racing",
                        status: true,
                        link: "/sportsbook/greyhound-racing",
                        hidden: !showHrAndGhr
                    },
                    // {
                    //     icon: "mdi-crown",
                    //     src:
                    //         process.env.APP_TITLE === "SuperWin"
                    //             ? "Fantasy"
                    //             : "fantasybookicon",
                    //     text: "menu.fantasybook",
                    //     status: true,
                    //     link: "/fantasybook"
                    // },
                    {
                        icon: "iconpe-live-casino",
                        src: "Live-Casino",
                        text: "menu.live_casino",
                        status: true,
                        link: "/casino"
                    },
                    // {
                    //     icon: "mdi-crown",
                    //     src: "Premium-Notebook",
                    //     text: "menu.premium_sportbook",
                    //     status: true,
                    //     link: "/premium-sportsbook"
                    // },
                    {
                        icon: "iconpe-election",
                        src: "Election",
                        text: "election",
                        status: true,
                        link: "/sportsbook/Election"
                    },
                    // {
                    //   icon: 'iconpe-live-casino',
                    //   src: 'live-casino',
                    //   text: 'Casino',
                    //   status: true,
                    //   link: '/casino'
                    // },
                    // {
                    //     icon: "iconpe-live-casino",
                    //     src: "Live-Casino",
                    //     text: "menu.live_casino",
                    //     status: true,
                    //     link: "/casino"
                    // },
                    {
                        icon: "iconpe-live-casino",
                        src: "fundlist",
                        text: "Crash Games",
                        status: true,
                        link: "/live-casino"
                    },
                    {
                        icon: "iconpe-live-cards",
                        src: "Live-Card",
                        text: "menu.live_card",
                        status: true,
                        link: "/live-cards"
                    },
                    // {
                    //     icon: "iconpe-live-cards",
                    //     src: "rummy-icon",
                    //     text: "menu.live_event",
                    //     status: true,
                    //     link: "/rummy-poker"
                    // },
                    {
                        icon: "iconpe-slot",
                        src: "Slot-game",
                        text: "menu.slot_games",
                        status: true,
                        link: "/casino-slots"
                    }
                ]
            },
            valid: true,
            showPassword: false,
            form: {
                userName: "",
                password: "",
                countryCode: "91",
                captcha: ""
            },
            siteKey: "6Lda0YwaAAAAAAYtJQ3v4x7KRRxN6NUSddcxAADd", // image
            // siteKey: '6LdBv4waAAAAABzLkb40HaXTT7LO7Pw-sPvSzuCU', // checkbox
            token: "",
            rules: {
                userName: [(v) => !!v || "Email / Mobile number is required"],
                fpsUserName: [(v) => !!v || "Username is required"],
                password: [
                    (v) => !!v || "Password is required",
                    (v) =>
                        !(v && v.length < 6) ||
                        "Password must be of 6 characters or more",
                    (v) =>
                        !(v && v.split(" ").join("").length < v.length) ||
                        "Password cannot contain spaces!"
                ],
                captcha: [(v) => !!v || "Captcha is required"],
                email: [
                    (v) => !!v || "Email is required",
                    (v) => /.+@.+\..+/.test(v) || "Invalid Email Address"
                ]
            },
            CDN_IMG_URL: process.env.CDN_IMG_URL
        }
    },
    computed: {
        ...mapState({
            fantasyOnOff: (state) => state.user.fantasyConfig
        }),
        megaMenuDrawer: {
            get() {
                return this.$store.getters["megaMenuDrawer/value"]
            },
            set(v) {
                return this.$store.commit("megaMenuDrawer/toggle", v)
            }
        },
        version() {
            return this.$store.state.profile.appversion
        },
        ...mapState(["title"]),
        ipBlock() {
            return this.$store.state.ip.blockIpData
        },
        login() {
            return this.$auth.loggedIn
        },
        currency() {
            return this.$store.state.currency.data
        },
        userBalanceData() {
            return this.$store.state.userBalance.userBalanceData
        },
        selectedCurrency() {
            return this.$store.state.currency.selectedCurrency
        },
        user() {
            return this.$store.state.profile.data
        },
        error() {
            return this.$store.state.authenticate.error
        },
        readyToSubmit() {
            return this.$store.state.contest.readyToSubmit
        },
        predictions() {
            return this.$store.state.contest.predictions
        },
        showMaintenanceModal() {
            return this.$store.state.profile.showMaintenanceModal
        },
        activeBar() {
            return (
                this.$route.name !== "inplay" &&
                this.$route.name !== "sportsbook-category" &&
                this.$route.name !== "sportsbook-category-id" &&
                this.$route.name !== "casino-live-casino" &&
                this.$route.name !== "live-cards" &&
                this.$route.name !== "live-games" &&
                this.$route.name !== "casino-slots" &&
                this.$route.name !== "racing" &&
                this.$route.name !== "premium-sportsbook" &&
                this.$route.name !== "casino" &&
                this.$route.name !== "live-casino" &&
                this.$route.name !== "fantasybook"
            )
        },
        ...mapState({ loading: (state) => state.search.loading }),
        searchModal: {
            get() {
                return this.$store.getters["search/modalOpen"]
            },
            set(v) {
                return this.$store.commit("search/set_modal", v)
            }
        },
        drawer: {
            get() {
                return this.$store.getters["drawer/value"]
            },
            set(v) {
                return this.$store.commit("drawer/toggle", v)
            }
        },
        drawer1: {
            get() {
                return this.$store.getters["drawer/value1"]
            },
            set(v) {
                return this.$store.commit("drawer/toggle1", v)
            }
        },
        route() {
            return this.$route.name
        },
        getWhatsappData() {
            return this.$store.state.user.whatsappData
        },
        ...mapState({
            markets: (state) => state.matchInside.data,
            matchIds: (state) => state.placeBet.matchIds,
            userLoginVerify: (state) => state.user.userLoginVerify,
            marketData: (state) => state.matchInner.marketData,
            premiumFancy: (state) => state.bookmakerMarket.fancyData
        }),
        depositWhatsappLink() {
            return sessionStorage.getItem("depositWhatsapp")
        },
        gameName() {
            return this.$route.params.category
        }
    },
    watch: {
        login() {
            if (this.user) {
                const userData = {
                    firstName: this.user.name,
                    lastName: "",
                    email: this.user.email,
                    phone: this.user.mobileNo,
                    setExternalId: this.user._id
                }
                // Reinitialize Freshchat widget with user info
                this.$freshchat.updateUser(userData)

                this.listenToAllSocket()
                this.listenToBookSocket()
            }
        },
        showElection() {
            return JSON.parse(localStorage.getItem("showElectionData"))
        },
        fantasyOnOff() {
            if (this.$auth.loggedIn) {
                this.activeGames()
            } else {
                this.beforLoginFantasyOnOff()
            }
        },
        $route(to, from) {
            this.path = this.$route.path
        },
        selected(val) {
            if (val) {
                const event = this.items.find((v) => v._id === val)
                this.$router.push({
                    path: `/sportsbook/${event.eventType.name}/${event.parentCategory._id}/${val}`
                })
                this.searchModal = false
            }
        },
        async search(searchText) {
            if (searchText && searchText.length < 3) {
                return
            }
            await this.$store.dispatch("search/searchEvent", {
                searchText
            })
            this.items = this.$store.state.search.results
        }
    },
    async created() {
        if (this.version.projectCode === "bd-new") {
            this.form.countryCode = "880"
            this.BDcheck = true
        } else {
            this.form.countryCode = "91"
        }
        if (process.client) {
            if (this.$auth.loggedIn) {
                this.$store.commit(
                    "timezone/initialize",
                    this.$auth.user.timezone
                )
                this.$store.dispatch(
                    "socketMain/joinRoomsForUser",
                    socket.commonSocket.id
                )
                await this.joinFairplaySocketRooms()
            }
            let userId, customSession
            customSession = true
            // bookmaker = true
            const martketOnOff = []
            if (this.$auth.loggedIn) {
                userId = this.$auth.user._id
                // accessToken = this.$auth.getToken("customLocal")
                customSession = this.$auth.user.customSession
                // bookmaker = this.$auth.user.bookmaker
                let marketStatus = {}
                if (
                    this.$route.params.category === "Cricket" &&
                    !this.$auth.user.tiedMatch
                ) {
                    marketStatus = {
                        status: this.$auth.user.tiedMatch,
                        name: "Tied Match"
                    }
                    martketOnOff.push(marketStatus)
                }
                if (
                    this.$route.params.category === "Cricket" &&
                    !this.$auth.user.completedMatch
                ) {
                    marketStatus = {
                        status: this.$auth.user.completedMatch,
                        name: "Completed Match"
                    }
                    martketOnOff.push(marketStatus)
                }
                if (localStorage.getItem("accessTokenNewWallet")) {
                    const abc = localStorage.getItem("accessTokenNewWallet")
                    const jsonToken = JSON.parse(abc)
                    if (jsonToken && jsonToken._id) {
                        // STEP1: Normal Sockets
                        socket.commonSocket.on(
                            "AllSocket_" + jsonToken._id,
                            (eventKeys) => {
                                this.insideSocketFunction(
                                    eventKeys,
                                    jsonToken._id,
                                    jsonToken.accessToken
                                )
                            }
                        )
                        if (jsonToken && jsonToken.sbbonusid) {
                            // STEP2 : Sports Bonus Sockets
                            socket.commonSocket.on(
                                "AllSocket_" + jsonToken.sbbonusid,
                                (eventKeys) => {
                                    this.insideSocketFunction(
                                        eventKeys,
                                        jsonToken.sbbonusid,
                                        jsonToken.accessToken_sp
                                    )
                                }
                            )
                        }
                        if (jsonToken && jsonToken.bonusid) {
                            // STEP3 : Bonus Sockets
                            socket.commonSocket.on(
                                "AllSocket_" + jsonToken.bonusid,
                                (eventKeys) => {
                                    this.insideSocketFunction(
                                        eventKeys,
                                        jsonToken.bonusid,
                                        jsonToken.accessToken_bonus
                                    )
                                }
                            )
                        }
                    }
                }
                this.listenToAllSocket()
                this.listenToBookSocket()
            }

            socket.commonSocket.on(
                "BetSocket_" + this.$auth.user._id,
                (eventKeys) => {
                    console.log({ BetSocket_: eventKeys })

                    if (
                        this.$route.path.startsWith("/sportsbook/") ||
                        this.$route.path === "/"
                    ) {
                        if (
                            eventKeys.eventKey ===
                                "BetExecuted_" + this.$auth.user._id ||
                            eventKeys.eventKey ===
                                "premium_bet_executed_" + this.$auth.user._id
                        ) {
                            if (
                                eventKeys?.status &&
                                eventKeys?.status === "matched"
                            ) {
                                this.showEdgeLight()
                            }
                        }
                    }
                }
            )

            socket.commonSocket.on("connect", async () => {
                // let matchIds
                let betfairId
                if (this.$route.params.betfairId) {
                    this.$store.dispatch("socketCustomerService/joinRooms", {
                        socketId: socket.rateSocket.id,
                        betfairId: this.$route.params.betfairId
                    })
                } else {
                    if (this.markets && this.markets.length > 0) {
                        betfairId = this.getMatchOddsId(this.markets)
                        // matchIds = map(this.markets, (match) => match.betfairId)
                    }
                    if (betfairId) {
                        this.$store.dispatch(
                            "socketCustomerService/joinRooms",
                            {
                                socketId: socket.rateSocket.id,
                                betfairId
                            }
                        )
                    }
                }
                if (this.$route.params.subCategory === "UOFGame") {
                    await this.$store.dispatch(
                        "socketPremium/joinRoomsNonBetFairEnable",
                        {
                            socketId: socket.commonSocket.id,
                            eventId: this.$route.params.id
                        }
                    )
                }
                // fantasy code start
                if (process.client) {
                    if (
                        sessionStorage.getItem("getOneUser") &&
                        this.$route.name ===
                            "fantasybook-match-inner-parentCategory-betfairId-game-gameType-contestId"
                    ) {
                        if (constants.fantasyProShow) {
                            this.$store.dispatch(
                                "fantasySockets/joinFantasyConfigRoom",
                                {
                                    socketName: `fantasyConfiguration`,
                                    socketId: socket1.id
                                }
                            )
                        }
                        this.$store.dispatch(
                            "fantasySockets/joinRoomMaintenenace",
                            {
                                socketName: `getWebisteMaintenance`,
                                socketId: socket1.id
                            }
                        )
                        const userDetail = JSON.parse(
                            encryptor.decrypt(
                                sessionStorage.getItem("getOneUser")
                            )
                        )
                        if (
                            userDetail &&
                            userDetail.data &&
                            userDetail.data.userData
                        ) {
                            this.userId = userDetail.data.userData._id
                            this.$store.dispatch(
                                "fantasySockets/joinFinalFantasyRoomMarket",
                                {
                                    socketName: `fantasyResultDeclare-${this.userId}`,
                                    socketId: socket1.id
                                }
                            )
                        }
                        this.$store.dispatch(
                            "fantasySockets/joinFancyFantasyRoomMarket",
                            {
                                socketName: `fantasyFancyResultDeclare`,
                                betfairId: this.$route.params.betfairId,
                                socketId: socket1.id
                            }
                        )
                        this.$store.dispatch(
                            "fantasySockets/joinFantasyUOFRoomMarket",
                            {
                                socketName: `fantasyUOFResultDeclare`,
                                betfairId: this.$route.params.betfairId,
                                socketId: socket1.id
                            }
                        )
                    }
                }
                // fantasy code end
                if (
                    this.$route.name === "sportsbook-category-subCategory-id" ||
                    this.$route.name ===
                        "sportsbook-category-subCategory-id-betradar"
                ) {
                    this.betradarId = await this.getBetradarID(this.markets)
                    if (this.$route.params.category) {
                        this.getAllUOFMarketsByEventId(this.betradarId, "")
                        this.$store.dispatch("socketPremium/joinRooms", {
                            socketId: socket.commonSocket.id,
                            marketId: this.betradarId,
                            gameName:
                                this.$route.params.subCategory === "UOFGame"
                                    ? this.gameName
                                    : undefined
                        })
                        // Artemis Bookmaker
                        if (
                            this.$route.params.category &&
                            (!this.$auth.user ||
                                (this.$auth?.user && this.$auth.user.artemis))
                        ) {
                            this.getArthemisBookmaker(
                                this.$route.params.category,
                                "",
                                true
                            )
                            if (this.$auth.user && this.$auth.loggedIn) {
                                this.getArthemisBookmakerBook(
                                    this.$route.params.category
                                )
                            }
                        }
                        if (
                            this.$route.params.category &&
                            (!this.$auth.user ||
                                (this.$auth?.user &&
                                    this.$auth.user.artemisFancy))
                        ) {
                            // fancy bookmaker
                            this.getArthemisPremiumFancy(
                                this.$route.params.category,
                                "",
                                true
                            )

                            if (this.$auth.user && this.$auth.loggedIn) {
                                this.getArthemisFancyBook(
                                    this.$route.params.category
                                )
                            }
                        }
                        // End Artemis Bookmaker
                        console.log("commonSocket connected")
                    }
                    if (
                        this.$route.params.category &&
                        this.$auth &&
                        this.$auth.loggedIn &&
                        this.$auth.user &&
                        this.$auth.user.UOFMarket === true
                    ) {
                        await this.$store.dispatch("betBooks/getAllPremium", {
                            payload: this.betradarId,
                            refresh: this.refresh
                        })
                    }
                }
                this.$store.dispatch("socketMain/joinRoomsWithoutLogin", {
                    socketId: socket.commonSocket.id,
                    rejoin: false
                })
                // if (
                //     this.$route.name === "sportsbook-category-subCategory-id" ||
                //     this.$route.name ===
                //         "sportsbook-category-subCategory-id-betradar"
                // ) {
                //     this.$store.dispatch("matchInside/getLineSession", {
                //         parentId: this.$route.params.id
                //     })
                // }
                if (this.$auth.loggedIn) {
                    this.verifyLoginedUser()
                    this.$store.dispatch(
                        "openBets/getMyCurrentBetStatus",
                        false
                    )
                    this.$store.dispatch(
                        "openBets/getMyCurrentPremiumBet",
                        false
                    )
                    this.$store.dispatch(
                        "openBets/getMyCurrentPremiumRawBet",
                        false
                    )
                    this.$store.dispatch(
                        "openBets/getMyCurrentBetStatusBookmakerMarket",
                        false
                    )
                    this.$store.dispatch("userBalance/getCurrentBalance")
                    this.$store.dispatch(
                        "socketMain/joinRoomsForUser",
                        socket.commonSocket.id
                    )
                    this.$store.dispatch("socketMain/joinRooms", {
                        socketId: socket.commonSocket.id,
                        rejoin: false
                    })
                    // if (
                    //   this.$route.params.id ||
                    //   this.$route.params.name === 'sportsbook'
                    // ) {
                    //   this.$store.dispatch(
                    //     'betBooks/getAll',
                    //     matchIds,
                    //     this.refresh === false
                    //   )
                    // }
                    // fantasy code start
                    if (
                        this.$route.name ===
                            "fantasybook-match-inner-parentCategory-betfairId-game-gameType-contestId" ||
                        this.$route.name ===
                            "fantasybook-users-leaderboard-parentCategory-userId-betfairId-game-status-contestId-playerId"
                    ) {
                        this.betradarId = this.marketData?.betradarId
                        if (
                            this.betradarId &&
                            this.$route.params.game === "Cricket"
                        ) {
                            this.getAllUOFMarketsByEventId(this.betradarId, "")
                            this.$store.dispatch("socketPremium/joinRooms", {
                                socketId: socket.commonSocket.id,
                                marketId: this.betradarId
                            })
                            console.log("commonSocket connected")
                        }
                        if (
                            this.$route.params.game === "Cricket" &&
                            this.$auth &&
                            this.$auth.loggedIn &&
                            this.$auth.user &&
                            this.$auth.user.UOFMarket === true
                        ) {
                            await this.$store.dispatch(
                                "betBooksFantasy/getAllPremium",
                                {
                                    payload: this.betradarId,
                                    refresh: this.refresh
                                }
                            )
                        }
                    } // fantasy code end
                }
            })
            socket.rateSocket.on("connect", async () => {
                if (
                    this.$route?.name === "sportsbook" ||
                    this.$route?.name === "sportsbook-category"
                ) {
                    if (this.$route.params.subCategory !== "UOFGame") {
                        const gameName = [
                            "horse-racing",
                            "greyhound-racing"
                        ].includes(this.$route.params.category)
                            ? this.fromKebabToNormalCase(
                                  this.$route.params.category
                              )
                            : upperFirst(this.$route.params.category)
                        await this.$store.dispatch(
                            "sportsbook/getMarketsById",
                            {
                                game: gameName,
                                userId,
                                loading: true,
                                gameName: this.$route.params.subCategory
                            }
                        )
                        this.$store.dispatch(
                            "betBooks/getAll",
                            this.matchIds,
                            this.refresh === false
                        )
                        // await this.$store.dispatch('matchInside/getMarketsById', {
                        //   game: gameName,
                        //   parentId: this.$route.params.id,
                        //   userId,
                        //   loading: false,
                        //   bookmaker,
                        //   martketOnOff,
                        //   gameName: this.$route.params.subCategory
                        // })
                    } else {
                        await this.$store.dispatch(
                            "matchInside/getMarketsById",
                            {
                                game: upperFirst(this.$route.params.category),
                                gameType: this.$route.params.subCategory,
                                betradarId: this.$route.params.id,
                                gameName: "UOFGame"
                            }
                        )
                        // await this.$store.dispatch('matchInside/getCustomMarketAndRunner', {
                        //   parentId: this.$route.params.id
                        // })
                        // await this.$store.dispatch('matchInside/getLineSession', {
                        //   parentId: this.$route.params.id
                        // })
                    }
                } else if (
                    this.$route.name === "sportsbook-category-subCategory-id" ||
                    this.$route.name ===
                        "sportsbook-category-subCategory-id-betradar"
                ) {
                    if (this.$route.params.subCategory !== "UOFGame") {
                        const gameName = [
                            "horse-racing",
                            "greyhound-racing"
                        ].includes(this.$route.params.category)
                            ? this.fromKebabToNormalCase(
                                  this.$route.params.category
                              )
                            : upperFirst(this.$route.params.category)
                        await this.$store.dispatch(
                            "matchInside/getMarketsById",
                            {
                                game: gameName,
                                parentId: this.$route.params.id,
                                userId,
                                loading: false,
                                bookmaker: this.$auth.loggedIn
                                    ? this.$auth.user.bookmaker
                                    : true,
                                martketOnOff,
                                gameName: this.$route.params.subCategory
                            }
                        )
                        await this.getFancy(
                            this.$route.params.category,
                            customSession
                        )
                        if (
                            this.getMatchOddsId(this.markets) &&
                            (this.$route.params.category !== "Cricket" ||
                                customSession === true)
                        ) {
                            socket.rateSocket.on(
                                "market_" + this.getMatchOddsId(this.markets),
                                (data) => {
                                    this.$store.commit(
                                        "matchInside/set_fancy",
                                        data
                                    )
                                }
                            )
                        }
                    }
                    if (this.$auth && this.$auth.loggedIn) {
                        this.$store.dispatch(
                            "betBooks/get",
                            this.matchIds,
                            this.refresh === false
                        )
                        this.$store.dispatch("betBooks/getAllPremium", {
                            payload: this.markets,
                            refresh: this.refresh
                        })
                        // this.$store.dispatch('betBooks/getAllBookmaker', {
                        //   dataSet:
                        //     this.$route.params.betradar || this.getEventId(this.markets),
                        //   refresh: this.refresh
                        // })
                    }
                }
                if (
                    this.$route.params.subCategory === "UOFGame" &&
                    this.$route.params.category &&
                    this.betradarId &&
                    (!this.$auth.user ||
                        (this.$auth &&
                            this.$auth.user &&
                            this.$auth.user.UOFMarket))
                ) {
                    socket.commonSocket.on(
                        "odds_change_" + this.betradarId,
                        (socketData) => {
                            this.getAllUOFMarketsByEventId(
                                this.betradarId,
                                socketData
                            )
                        }
                    )
                    socket.commonSocket.on(
                        "uof_refresh_" + this.gameName,
                        () => {
                            this.getAllUOFMarketsByEventId(this.betradarId)
                        }
                    )
                }
                if (
                    this.$route.params.betfairId &&
                    this.$route.name ===
                        "fantasybook-match-inner-parentCategory-betfairId-game-gameType-contestId"
                ) {
                    socket.rateSocket.on(
                        "market_" + this.$route.params.betfairId,
                        (data) => {
                            this.$store.commit(
                                "matchInner/set_single_fancy",
                                data
                            )
                        }
                    )
                    await this.$store.dispatch("matchInner/getMarketsById", {
                        marketId: this.$route.params.betfairId,
                        contestId: this.$route.params.contestId,
                        game: this.$route.params.game,
                        status: "Enable",
                        parentId: this.$route.params.parentCategory
                    })
                }

                this.$store.dispatch(
                    "socketRate/joinRooms",
                    socket.rateSocket.id
                )
                this.$store.dispatch(
                    "socketBookmaker/joinRooms",
                    socket.rateSocket.id
                )

                if (this.$route.name === "index") {
                    this.$store.dispatch("inplay/get", {
                        loading: false,
                        upComing: true
                    })
                    this.$store.dispatch("inplay/get", {
                        loading: false,
                        upComing: false
                    })
                    await Promise.all([
                        this.$store.dispatch(
                            "socketInplayRate/joinRooms",
                            socket.rateSocket.id
                        ),
                        this.$store.dispatch(
                            "socketBookmaker/joinRooms",
                            socket.rateSocket.id
                        )
                    ])
                }

                // let matchIds

                if (
                    this.$route.params.betfairId &&
                    this.$route.name ===
                        "fantasybook-match-inner-parentCategory-betfairId-game-gameType-contestId"
                ) {
                    this.$store.dispatch("socketCustomerService/joinRooms", {
                        socketId: socket.rateSocket.id,
                        betfairId: this.$route.params.betfairId
                    })
                } else {
                    let betfairId
                    if (this.markets.length > 0) {
                        betfairId = this.getMatchOddsId(this.markets)
                    }
                    if (betfairId) {
                        this.$store.dispatch(
                            "socketCustomerService/joinRooms",
                            {
                                socketId: socket.rateSocket.id,
                                betfairId
                            }
                        )
                    }
                }
                if (this.$auth.loggedIn) {
                    // this.verifyLoginedUser()
                    // this.$store.dispatch(
                    //     "openBets/getMyCurrentBetStatus",
                    //     false
                    // )
                    // this.$store.dispatch(
                    //     "openBets/getMyCurrentPremiumBet",
                    //     false
                    // )
                    this.$store.dispatch(
                        "matchInner/getMyCurrentPremiumRawBet",
                        {
                            dataSet: this.$route.params.betfairId
                        }
                    )
                    // this.$store.dispatch(
                    //     "openBets/getMyCurrentPremiumRawBet",
                    //     false
                    // )
                    // this.$store.dispatch("userBalance/getCurrentBalance")
                    this.$store.dispatch(
                        "socketMain/joinRoomsForUser",
                        socket.commonSocket.id
                    )
                    this.$store.dispatch("socketMain/joinRooms", {
                        socketId: socket.commonSocket.id,
                        rejoin: false
                    })
                }
            })
        }
        // debounce(() => {
        // this.$store.dispatch('socketMain/socketFailureLog', 'err', 'errorData')
        // }, 10000)
        // client-side
        socket.commonSocket.on("connect_error", (err) => {
            // eslint-disable-next-line nuxt/no-globals-in-created
            if (process.client) {
                if (window.navigator.onLine) {
                    const errorData = {}
                    if (this.$auth.loggedIn) {
                        errorData.userId = this.$auth.user._id
                    }
                    debounce(() => {
                        this.$store.dispatch(
                            "socketMain/socketFailureLog",
                            err,
                            errorData
                        )
                    }, 10000)
                }
            }
        })
        this.path = this.$route.path
        this.$store.dispatch("profile/getDeploymentVersion")
        await this.$store.dispatch("user/getconfigs")
        if (
            this.$auth &&
            this.$store.state &&
            this.$store.state.profile &&
            this.$store.state.profile.data
        ) {
            const userData = {
                firstName: this.$store.state.profile.data.name,
                lastName: "",
                email: this.$store.state.profile.data.email,
                phone: this.$store.state.profile.data.mobileNo,
                setExternalId: this.$store.state.profile.data._id
            }
            // Reinitialize Freshchat widget with user info
            this.$freshchat.updateUser(userData)
        }
    },
    async mounted() {
        if (constants.fantasyProShow) {
            this.$store.dispatch("user/getFantasyConfigs")
        }
        if (this.$auth.loggedIn) {
            this.activeGames()
            this.$store.dispatch("user/getWhatAppDepositSetting")
        }
        this.$store.dispatch("user/checkAffiliateProcess", this.$route)
        if (process.client) {
            localStorage.removeItem("user_clickid")
            if (this.$route.query.clickid) {
                localStorage.setItem("user_clickid", this.$route.query.clickid)
            }
        }
        this.checkCookie()
        this.path = this.$route.path

        socket1.on("getWebisteMaintenance", async (data) => {
            await this.$store.dispatch("profile/getMaintenance")
        })
        if (constants.fantasyProShow) {
            this.$store.dispatch("fantasySockets/joinFantasyConfigRoom", {
                socketName: `fantasyConfiguration`,
                socketId: socket1.id
            })
        }
        this.$store.dispatch("fantasySockets/joinRoomMaintenenace", {
            socketName: `getWebisteMaintenance`,
            socketId: socket1.id
        })
        socket1.on("getWebisteMaintenance", async (data) => {
            await this.$store.dispatch("profile/getMaintenance")
            if (
                this.$store.state.profile.underMaintenance &&
                this.$store.state.profile.underMaintenance.value
            ) {
                this.$router.push("/maintenance")
            } else if (
                this.$route.path &&
                this.$route.path === "/maintenance"
            ) {
                this.$router.push("/")
            }
            if (
                this.$store.state.profile.walletUnderMaintenance &&
                this.$store.state.profile.walletUnderMaintenance.value
            ) {
                this.$store.commit("profile/set_showMaintenanceModal", true)
                this.$router.push("/")
            }
        })
        if (constants.fantasyProShow) {
            socket1.on("fantasyConfiguration", async (data) => {
                await this.$store.dispatch("user/getFantasyConfigs")
                this.beforLoginFantasyOnOff()
            })
        }
        // this.joinSocketRooms()
    },
    beforeDestroy() {
        if (this.userId) {
            this.$store.dispatch("fairplaySockets/leaveNotificationRoom", {
                userId: this.userId,
                socket1Id: socket1.id
            })
            this.$store.dispatch("fairplaySockets/leaveBonusRoom", {
                userId: this.userId,
                socket1Id: socket1.id
            })
            this.$store.dispatch("fairplaySockets/leaveRoomForBlockUser", {
                userId: this.userId,
                socket1Id: socket1.id
            })
            this.$store.dispatch("fairplaySockets/leaveClearUserBonusRoom", {
                userId: this.userId,
                socket1Id: socket1.id
            })
        }
        if (constants.fantasyProShow) {
            this.$store.dispatch("fantasySockets/leaveFantasyConfigRoom", {
                socketName: `fantasyConfiguration`,
                socketId: socket1.id
            })
        }
        socket1.off(`sendNotificationToUser-${this.userId}`)
        if (constants.fantasyProShow) {
            socket1.off("fantasyConfiguration")
        }
        if (this.$auth.loggedIn) {
            socket.commonSocket.off("AllSocket_" + this.$auth.user._id)
            socket.commonSocket.off("BookSocket_" + this.$auth.user._id)
        }
        if (this.$route.params.subCategory === "UOFGame") {
            this.$store.dispatch("socketPremium/leaveRoomsNonBetFairEnable", {
                eventId: this.$route.params.id || this.markets[0].eventId
            })
        }
        socket.commonSocket.off("BetSocket_" + this.$auth.user._id)
        if (this.edgeLightTimeout) {
            clearTimeout(this.edgeLightTimeout)
        }
    },
    methods: {
        async insideSocketFunction(eventKeys, userId, accessToken) {
            console.log("socket called header")
            if (
                eventKeys.eventKey === "Balance_" + userId ||
                eventKeys.eventKey === "balanceWithData_" + userId ||
                eventKeys.eventKey === "winnerDeclared-fancy-" + userId
            ) {
                setTimeout(() => {
                    this.$store.dispatch("userBalance/getCurrentBalance")
                }, 100)
                // this.$store.dispatch("userBalance/getMemberNetExposure")
                this.$store.dispatch("userBalance/getPendingBonusSum")
            } else if (
                eventKeys.eventKey ===
                "logout_" + accessToken + "_" + userId
            ) {
                this.$store.dispatch("user/logout")
                this.$store.commit("snackbar/open", {
                    text: "Your session has ended, please login.",
                    color: "error"
                })
            } else if (eventKeys.eventKey === "Rt_Invalidation_" + userId) {
                this.$store.commit("snackbar/open", {
                    text: eventKeys.message,
                    color: "error"
                })
                const betId = await this.getBetradarID(this.markets)
                await this.$store.dispatch("betBooks/getAllPremium", {
                    dataSet: betId,
                    refresh: true
                })
                this.$store.dispatch("openBets/getMyCurrentBetStatus", false)
                this.$store.dispatch("openBets/getMyCurrentPremiumBet", false)
                this.$store.dispatch(
                    "openBets/getMyCurrentPremiumRawBet",
                    false
                )
            } else if (eventKeys.eventKey === "BetCancelled_" + userId) {
                this.$store.commit("snackbar/open", {
                    text: eventKeys.message,
                    color: "error"
                })
                this.$store.dispatch("openBets/getMyCurrentBetStatus", false)
                this.$store.dispatch("openBets/getMyCurrentPremiumBet", false)
                this.$store.dispatch(
                    "openBets/getMyCurrentPremiumRawBet",
                    false
                )
                this.$store.dispatch(
                    "openBets/getMyCurrentBetStatusBookmakerMarket",
                    false
                )
            }
        },
        async getAllUOFMarketsByEventId(markets, socketData) {
            await this.$store.dispatch(
                "matchInside/getAllUOFMarketsByEventId",
                {
                    payload: markets,
                    socketData
                }
            )
        },
        openStore() {
            if (process.client) {
                if (
                    this.$auth.loggedIn &&
                    localStorage.getItem("accessToken")
                ) {
                    return `${
                        process.env.FAIRPLAY_STORE_URL
                    }/?u=${localStorage.getItem("accessToken")}`
                }
            }
        },
        async getArthemisBookmakerBook(category) {
            if (category === "Cricket") {
                await this.$store.dispatch("betBooks/getAllBookmaker", {
                    dataSet:
                        this.$route.params.betradar ||
                        this.getEventId(this.markets),
                    refresh: this.refresh
                })
            }
        },
        async getArthemisBookmaker(category, socketData, status) {
            const betfairId =
                this.$route.params.betradar || this.getEventId(this.markets)
            this.loadingBookmakerMarket = true
            if (category === "Cricket" && betfairId) {
                this.loadingBookmakerMarket = false
                await this.$store.dispatch("bookmakerMarket/get", {
                    betfairId,
                    socketData
                })
                if (status) {
                    this.$store.dispatch(
                        "socketBookmakerMarket/joinRoomsIndividual",
                        {
                            socketId: socket.commonSocket.id,
                            gameName: this.gameName,
                            betfairId
                        }
                    )
                    this.$store.dispatch(
                        "socketBookmakerMarket/joinRoomsEvent",
                        {
                            socketId: socket.commonSocket.id,
                            gameName: this.gameName,
                            betfairId
                        }
                    )
                    this.$store.dispatch(
                        "socketBookmakerMarket/joinRoomsEventEnableDisable",
                        {
                            socketId: socket.commonSocket.id,
                            gameName: this.gameName,
                            betfairId
                        }
                    )
                    this.$store.dispatch(
                        "socketBookmakerMarket/joinRoomsBookmaker",
                        {
                            socketId: socket.commonSocket.id,
                            gameName: this.gameName,
                            betfairId
                        }
                    )
                    this.$store.dispatch(
                        "socketBookmakerMarket/joinRooms",
                        socket.rateSocket.id
                    )
                }
            }
        },

        async getArthemisPremiumFancy(category, socketData, status) {
            const betfairId =
                this.$route.params.betradar || this.getEventId(this.markets)
            this.loadingBookmakerFancys = true
            if (category === "Cricket" && betfairId) {
                this.loadingBookmakerFancys = false
                await this.$store.dispatch("bookmakerMarket/getFancy", {
                    betfairId,
                    socketData
                })
                if (status) {
                    this.$store.dispatch(
                        "socketBookmakerMarket/joinRoomsFancy",
                        {
                            socketId: socket.commonSocket.id,
                            gameName: this.gameName,
                            betfairId
                        }
                    )
                }
            }
        },
        async getArthemisFancyBook(category) {
            if (category === "Cricket") {
                await this.$store.dispatch("betBooks/getFancyBook", {
                    dataSet:
                        this.$route.params.betradar ||
                        this.getEventId(this.markets),
                    refresh: this.refresh
                })
            }
        },
        getEventId(markets) {
            if (markets) {
                let result = markets.find(
                    (market) => market.name.toLowerCase() === "match odds"
                )
                if (!result) {
                    result = markets[0]
                }
                return result?.eventId
            }
        },
        getBetradarID(markets) {
            if (markets) {
                let result = []
                result = markets?.find(
                    (market) => market?.name?.toLowerCase() === "match odds"
                )
                if (!result) {
                    result = markets[0]
                }
                return result?.betradarId
            }
        },
        beforLoginFantasyOnOff() {
            this.tabs.items.forEach((item, index) => {
                if (item.text === "menu.fantasybook") {
                    if (!this.$store.state.user.fantasyConfig) {
                        this.tabs.items.splice(index, 1)
                        return false
                    }
                }
            })
            this.tabs.mobileItems.forEach((item, index) => {
                if (item.text === "menu.fantasybook") {
                    if (!this.$store.state.user.fantasyConfig) {
                        this.tabs.items.splice(index, 1)
                        return false
                    }
                }
            })
        },

        goToWhatsapp() {
            if (this.getWhatsappData && this.getWhatsappData.whatsAppLink) {
                return this.getWhatsappData.whatsAppLink
            }
        },
        getMatchOddsId(markets) {
            if (markets) {
                let result = markets.find(
                    (market) => market?.name?.toLowerCase() === "match odds"
                )
                if (!result) {
                    result = markets[0]
                }
                return result?.betfairId
            }
        },
        getFancy(category, customSession) {
            if (
                (category !== "Cricket" || customSession === true) &&
                this.$route.params.subCategory !== "UOFGame"
            ) {
                this.$store.dispatch("matchInside/getFancy", {
                    market: this.$route.params.id
                })
            }
        },
        onSelect(data) {
            this.form.countryCode = data.dialCode
        },
        reload() {
            if (process.client) {
                window.location.reload(true)
            }
        },
        async verifyLoginedUser() {
            await this.$store.dispatch("user/checkLogin")
        },
        activeGames() {
            this.tabs.items = remove(this.tabs.items, (game) => {
                if (
                    this.$auth.user.sportsbook &&
                    (game.text === "menu.cricket" ||
                        game.text === "menu.soccer" ||
                        game.text === "menu.tennis" ||
                        game.text === "menu.inplay")
                ) {
                    return game
                } else if (
                    this.$auth.user.casino &&
                    game.text === "menu.live_casino"
                ) {
                    return game
                }
                if (this.$auth.user.casino && game.text === "Casino") {
                    return game
                } else if (
                    this.$auth.user.cardgame &&
                    game.text === "menu.live_card"
                ) {
                    return game
                } else if (
                    this.$auth.user.cardgame &&
                    game.text === "menu.live_event"
                ) {
                    return game
                } else if (
                    this.$auth.user.cardgame &&
                    game.text === "menu.slot_games"
                ) {
                    return game
                } else if (
                    this.$auth.user.premiumsportsbook &&
                    game.text === "menu.premium_sportbook"
                ) {
                    return game
                } else if (
                    this.$store.state.user.fantasyConfig &&
                    game.text === "menu.fantasybook"
                ) {
                    return game
                } else if (
                    this.$auth.user.fundist &&
                    game.text === "Crash Games"
                ) {
                    return game
                } else if (
                    this.$auth.user &&
                    this.$auth.user.sportsbook &&
                    this.$auth.user.horseRacing &&
                    game.text === "menu.horse_racing"
                ) {
                    return game
                } else if (
                    this.$auth.user &&
                    this.$auth.user.sportsbook &&
                    this.$auth.user.greyhoundRacing &&
                    game.text === "menu.greyhound_racing"
                ) {
                    return game
                }
                //  else if (
                //     this.$auth.user &&
                //     this.$auth.user.sportsbook &&
                //     this.$auth.user.cricket &&
                //     game.text === "menu.cricket"
                // ) {
                //     return game
                // } else if (
                //     this.$auth.user &&
                //     this.$auth.user.sportsbook &&
                //     this.$auth.user.soccer &&
                //     game.text === "menu.soccer"
                // ) {
                //     return game
                // } else if (
                //     this.$auth.user &&
                //     this.$auth.user.sportsbook &&
                //     this.$auth.user.tennis &&
                //     game.text === "menu.tennis"
                // ) {
                //     return game
                // }
            })

            this.tabs.mobileItems = remove(this.tabs.mobileItems, (game) => {
                if (
                    this.$auth.user.sportsbook &&
                    (game.text === "menu.sportsbook" ||
                        game.text === "menu.inplay" ||
                        game.text === "election")
                ) {
                    return game
                } else if (
                    this.$auth.user.casino &&
                    game.text === "menu.live_casino"
                ) {
                    return game
                }
                if (this.$auth.user.casino && game.text === "Casino") {
                    return game
                } else if (
                    this.$auth.user.cardgame &&
                    game.text === "menu.live_card"
                ) {
                    return game
                } else if (
                    this.$auth.user.cardgame &&
                    game.text === "menu.live_event"
                ) {
                    return game
                } else if (
                    this.$auth.user.cardgame &&
                    game.text === "menu.slot_games"
                ) {
                    return game
                } else if (
                    this.$auth.user.premiumsportsbook &&
                    game.text === "menu.premium_sportbook"
                ) {
                    return game
                } else if (
                    this.$store.state.user.fantasyConfig &&
                    game.text === "menu.fantasybook"
                ) {
                    return game
                }
            })
        },
        fromKebabToNormalCase(inputString) {
            return inputString
                .split("-") // Split by hyphens
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
                .join(" ") // Join words with spaces
        },
        // getWalletDetails(shortName) {
        //   this.$store.commit('currency/set_selectedCurrency', shortName)
        //   if (!this.currency[0]) return
        //   const currency = this.currency.find((x) => x.shortName === shortName)
        //   if (!currency) return
        //   this.$store.dispatch('wallet/getWalletDetails', {
        //     currency: currency._id
        //   })
        // },
        changeShowMaintenanceModel(value) {
            this.$store.commit("profile/set_showMaintenanceModal", value)
        },
        showSnackbar({ content, color }) {
            this.$store.commit("snackbar/open", {
                text: content,
                color
            })
        },
        back() {
            if (this.$route.path.includes("/markets/live-casino")) {
                this.$router.push("/markets/sportsbook/Cricket")
            } else {
                this.$router.go(-1)
            }
        },

        async validate() {
            let recaptchaToken = "null"
            if (process.client) {
                localStorage.clear()
                sessionStorage.clear()
            }
            if (this.$refs.loginForm.validate()) {
                this.loginLoading = true
                // this.form.userName = this.form.userName.toLowerCase()
                if (this.form.userName) {
                    try {
                        if (
                            this.ipBlock &&
                            this.ipBlock.data &&
                            this.ipBlock.data.data &&
                            this.ipBlock.data.status &&
                            this.ipBlock.data.status !== 200
                        ) {
                            this.showSnackbar({
                                content:
                                    this.ipBlock.data.message ||
                                    "Error code 507, Please contact admin",
                                color: "error"
                            })
                            return
                        }
                        this.form.captcha = recaptchaToken
                        const user = await this.$store.dispatch(
                            "authenticate/login",
                            this.form
                        )
                        if (!user) {
                            this.loginLoading = false
                            this.showSnackbar({
                                content: "Please try again",
                                color: "error"
                            })
                            this.$store.commit("authenticate/set_error", null)
                            return
                        } else if (
                            user &&
                            user.data &&
                            user.data.status &&
                            user.data.status === 200 &&
                            user.data.data
                        ) {
                            this.loginLoading = true
                            await this.allProcess(user)
                        } else if (user && user.data && user.data.error) {
                            // if (
                            //     user.data.error.data &&
                            //     user.data.error.data ===
                            //         "Invalid credentials" &&
                            //     this.setUp === "gb"
                            // ) {
                            //     // await this.checkAnotherTMforThisUser()
                            // } else {
                            this.loginLoading = false
                            for (const x in user.data.error) {
                                this.showSnackbar({
                                    content:
                                        user.data.error[x] ||
                                        "Please try again",
                                    color: "error"
                                })
                                this.$store.commit(
                                    "authenticate/set_error",
                                    null
                                )
                                break
                            }
                            if (
                                user.data.error.verifyUser &&
                                user.data.error.verifyUser == true
                            ) {
                                if (
                                    user.data.error.user &&
                                    user.data.error.user.mobileNo
                                ) {
                                    user.data.error.form = this.form
                                    this.$store.commit(
                                        "authenticate/set_error",
                                        user.data.error
                                    )
                                    this.$router.push("/login")
                                } else {
                                    user.data.error.form = this.form
                                    this.$store.commit(
                                        "authenticate/set_error",
                                        user.data.error
                                    )
                                }
                            }
                            return
                            // }
                        } else if (
                            user &&
                            user.data &&
                            user.data.status !== 200 &&
                            user.data.data &&
                            user.data.data.error
                        ) {
                            this.loginLoading = false
                            this.showSnackbar({
                                content:
                                    user.data.data.error || "Please try again",
                                color: "error"
                            })
                            return
                        } else {
                            this.loginLoading = false
                            this.showSnackbar({
                                content: "Please try again",
                                color: "error"
                            })
                            this.$store.commit("authenticate/set_error", null)
                            return
                        }
                    } catch (err) {
                        this.loginLoading = false
                        this.showSnackbar({
                            content:
                                err.message ||
                                "No Internet Connection. Please Try Again.",
                            color: "error"
                        })
                    }
                } else {
                    this.loginLoading = false
                    this.showSnackbar({
                        content: "Email / Mobile Number Required",
                        color: "error"
                    })
                }
            }
        },

        async allProcess(user) {
            this.loginLoading = true
            if (process.client) {
                if (this.form.checked) {
                    const cookie = this.form
                    cookie.countryCode = encryptor.encrypt(cookie.countryCode)
                    cookie.userName = encryptor.encrypt(cookie.userName)
                    cookie.password = encryptor.encrypt(cookie.password)
                    document.cookie = `countryCode=${cookie.countryCode}; secure; samesite=strict`
                    document.cookie = `userName=${cookie.userName}; secure; samesite=strict`
                    document.cookie = `password=${cookie.password}; secure; samesite=strict`
                } else {
                    document.cookie = `countryCode=; secure; samesite=strict; max-age=0`
                    document.cookie = `userName=; secure; samesite=strict; max-age=0`
                    document.cookie = `password=; secure; samesite=strict; max-age=0`
                }

                localStorage.setItem("accessToken", user.data.data.accessToken)
            }
            const abc = await this.$store.dispatch("profile/getProfile")
            if (abc && abc === "Failed") {
                return
            }
            if (
                user.data.data &&
                user.data.data.play &&
                user.data.data.play.data
            ) {
                await this.normalLogin(user.data.data.play)
            } else if (
                user.data.data &&
                user.data.data.play &&
                user.data.data.play.error
            ) {
                this.loginLoading = false
                this.showSnackbar({
                    content:
                        user.data.data.play.error || "Internal Server Error",
                    color: "error"
                })
                return
            } else {
                this.loginLoading = false
                this.showSnackbar({
                    content: "Internal Server Error",
                    color: "error"
                })
                return
            }
            //One Signal Device ID Stored Start
            try {
                if (process.client) {
                    const OS = window.OneSignal
                    console.log("os", OS, OS.getUserId())
                    if (OS) {
                        const deviceId = await OS.getUserId()
                        await this.$store.dispatch(
                            "fairplayLogin/saveUserDeviceId",
                            {
                                deviceId: deviceId ? deviceId : ""
                            }
                        )
                    }
                }
            } catch (error) {}
            //One Signal Device ID Stored End
            // await this.playLogin(savedUserData.data)
            // @@@@@@@@@@@
            if (this.readyToSubmit) {
                await this.saveQuizAnswers(user.data.data.amplify)
            } else {
                this.loginLoading = false
            }
            // localStorage.removeItem("user_affilates")
            if (process.env.fairplayEnvironment === "PROD") {
                this.sportsRadarLoginEvent({
                    id: user.data.data.amplify._id
                })
            }
            this.loginLoading = false
        },

        async checkAnotherTMforThisUser() {
            try {
                this.loginLoading = true
                let recaptchaToken = "null"
                this.form.captcha = recaptchaToken ? recaptchaToken : "NuLl"
                const user = await this.$store.dispatch(
                    "authenticate/loginAnotherDomain",
                    this.form
                )
                this.loginLoading = false
                if (!user) {
                    this.showSnackbar({
                        content: "Please try again",
                        color: "error"
                    })
                    this.$store.commit("authenticate/set_error", null)
                    return
                } else if (
                    user.data &&
                    user.data.status &&
                    user.data.status === 200
                ) {
                    let abc = await encryptor.encrypt(JSON.stringify(user))
                    abc = abc.replaceAll("+", "@")
                    if (process.client) {
                        var hostname = window.location.hostname
                        var mainDomainLink =
                            hostname && hostname === "localhost"
                                ? process.env.basicDomain
                                : hostname &&
                                  (hostname.includes("m.") ||
                                      hostname.includes("m-") ||
                                      hostname.includes("bd.") ||
                                      hostname.includes("www.") ||
                                      hostname.includes("fantasy."))
                                ? hostname.replace(
                                      /m.|m-|www.|bd.|fantasy./gi,
                                      ""
                                  )
                                : hostname
                        // var mainDomainLink = this.hostName(window.location.hostname)
                        window.location.replace(
                            `${process.env.frontendDomainUrl}${mainDomainLink}/login/?user=${abc}`
                        )
                    }
                } else if (user.data && user.data.error) {
                    for (const x in user.data.error) {
                        this.showSnackbar({
                            content: user.data.error[x] || "Please try again",
                            color: "error"
                        })
                        this.$store.commit("authenticate/set_error", null)
                        break
                    }
                    if (
                        user.data.error.verifyUser &&
                        user.data.error.verifyUser == true
                    ) {
                        if (
                            user.data.error.user &&
                            user.data.error.user.mobileNo
                        ) {
                            user.data.error.form = this.form
                            this.step = "confirmRegistrationForm"
                            this.$store.commit(
                                "authenticate/set_error",
                                user.data.error
                            )
                            this.confirmForm.mobileNo =
                                user.data.error.user.mobileNo
                            this.checkVerifySmsProcess()
                        } else {
                            user.data.error.form = this.form
                            this.$store.commit(
                                "authenticate/set_error",
                                user.data.error
                            )
                        }
                    }
                    return
                } else {
                    this.loginLoading = false
                    this.showSnackbar({
                        content: "Please try again",
                        color: "error"
                    })
                    this.$store.commit("authenticate/set_error", null)
                    return
                }
            } catch (error) {
                this.loginLoading = false
                console.log("error", error)
            }
        },

        sportsRadarLoginEvent(data) {
            // console.log('sportsRadarLoginEvent headerBar', data)
            try {
                srtmCommands.push({
                    event: "track.user.login",
                    payload: {
                        action: "complete",
                        userId: data.id
                    }
                })
                // console.log('srtmCommands headerBar', srtmCommands)
            } catch (err) {
                console.log(err)
            }
        },

        getCookie(name) {
            if (process.client) {
                var cookieArr = document.cookie.split(";")
                for (var i = 0; i < cookieArr.length; i++) {
                    if (cookieArr[i].includes("password=")) {
                        var cookiePair = cookieArr[i].split("password=")
                        cookiePair[0] = "password"
                    } else if (cookieArr[i].includes("userName=")) {
                        var cookiePair = cookieArr[i].split("userName=")
                        cookiePair[0] = "userName"
                    } else if (cookieArr[i].includes("countryCode=")) {
                        var cookiePair = cookieArr[i].split("countryCode=")
                        cookiePair[0] = "countryCode"
                    } else {
                        var cookiePair = cookieArr[i].split("=")
                    }
                    if (name == cookiePair[0].trim()) {
                        return cookiePair[1]
                    }
                }
                return null
            }
        },

        checkCookie() {
            var countryCode = this.getCookie("countryCode")
            var userName = this.getCookie("userName")
            var password = this.getCookie("password")
            const decryptUserName = encryptor.decrypt(userName)
            const decryptPassword = encryptor.decrypt(password)
            const decryptCountryCode = encryptor.decrypt(countryCode)
            if (countryCode != null && userName != null && password != null) {
                this.form.countryCode = decryptCountryCode
                this.form.userName = decryptUserName
                this.form.password = decryptPassword
                this.form.checked = true
            }
        },

        // onSuccess(token) {
        //   console.log('Succeeded:', token)
        // },
        // onExpired() {
        //   console.log('Expired')
        // },
        // onError(error) {
        //   console.log('Error happened:', error)
        // },
        async normalLogin(playData) {
            const json = {
                accessToken: playData.data.accessToken
            }
            try {
                localStorage.setItem(
                    "accessTokenNewWallet",
                    JSON.stringify(playData.data)
                )
                await this.$auth.loginWith("customLocal", {
                    baseURL: process.env.USERS_API_URL,
                    data: json
                })
                await Promise.all([
                    this.$store.dispatch("settings/getUserConfig")
                ])
                let redirectUrl
                if (this.$route.query && this.$route.query.redirectUrl) {
                    redirectUrl = this.$route.query.redirectUrl
                } else {
                    redirectUrl = "/"
                }
                this.loading = false
                this.$router.push(redirectUrl)
                if (!sessionStorage.getItem("vpnerror")) {
                    this.showSnackbar({
                        content: "Logged in successfully.",
                        color: "success"
                    })
                }
            } catch (error) {
                this.loginLoading = false
                if (
                    error &&
                    error.response &&
                    error.response.data &&
                    error.response.data.error
                ) {
                    this.$store.commit("snackbar/open", {
                        text: error.response.data.error,
                        color: "error"
                    })
                } else {
                    this.$store.commit("snackbar/open", {
                        text: "Invalid credentials, please try again!",
                        color: "error"
                    })
                }
            }
        },
        async playLogin(userData) {
            // console.log(userData, 'dd4455')
            const playExchLoginData = {
                // password: userData.playExchPwd,
                // deviceId: '',
                // siteOrigin: process.env.SITE_ORIGIN
                accessToken: userData.data.accessToken
            }
            // playExchLoginData.username =
            //   userData.username && userData.username.length > 0
            //     ? userData.username
            //     : userData.email
            try {
                await this.$auth.loginWith("customLocal", {
                    baseURL: process.env.USERS_API_URL,
                    data: playExchLoginData
                })
                await Promise.all([
                    this.$store.dispatch("settings/getUserConfig")
                ])
                let redirectUrl
                if (this.$route.query && this.$route.query.redirectUrl) {
                    redirectUrl = this.$route.query.redirectUrl
                } else {
                    redirectUrl = "/"
                }
                this.showSnackbar({
                    content: "Logged in successfully.",
                    color: "success"
                })
                await this.joinSocketRooms()
                this.loginLoading = false
                this.$router.push(redirectUrl)
            } catch (error) {
                this.loading = false
                if (
                    error &&
                    error.response &&
                    error.response.data &&
                    error.response.data.error
                ) {
                    this.$store.commit("snackbar/open", {
                        text: error.response.data.error,
                        color: "error"
                    })
                } else {
                    this.$store.commit("snackbar/open", {
                        text: "Invalid credentials, please try again!",
                        color: "error"
                    })
                }
            }
        },
        async joinSocketRooms() {
            if (this.$auth.loggedIn) {
                this.activeGames()
                this.$store.dispatch(
                    "socketMain/joinRoomsForUser",
                    socket.commonSocket.id
                )
                this.$store.dispatch("socketMain/joinRooms", {
                    socketId: socket.commonSocket.id,
                    rejoin: true
                })
                let userDetail = {}
                if (process.client) {
                    if (
                        sessionStorage &&
                        sessionStorage.getItem("getOneUser")
                    ) {
                        userDetail = JSON.parse(
                            encryptor.decrypt(
                                sessionStorage.getItem("getOneUser")
                            )
                        )
                    } else {
                        userDetail = await service.apiCallWithHeader(
                            "/User/getOneUser"
                        )
                    }
                }
                if (userDetail && userDetail.data && userDetail.data.userData) {
                    this.userId = userDetail.data.userData._id
                }
                if (this.userId) {
                    this.$store.dispatch(
                        "fairplaySockets/joinNotificationRoom",
                        {
                            userId: this.userId,
                            socket1Id: socket1.id
                        }
                    )
                    this.$store.dispatch("fairplaySockets/joinBonusRoom", {
                        userId: this.userId,
                        socket1Id: socket1.id
                    })
                    socket1.on(`userBonus-${this.userId}`, (data) => {
                        this.$store.dispatch("profile/getProfileForBonusSocket")
                    })
                    socket1.on(
                        `sendNotificationToUser-${this.userId}`,
                        (data) => {
                            this.$store.dispatch("profile/getNotifications")
                        }
                    )
                    // this.$store.dispatch("profile/getNotifications")
                }
            }
        },

        async joinFairplaySocketRooms() {
            let userDetail = {}
            if (process.client) {
                if (sessionStorage && sessionStorage.getItem("getOneUser")) {
                    userDetail = JSON.parse(
                        encryptor.decrypt(sessionStorage.getItem("getOneUser"))
                    )
                } else {
                    userDetail = await service.apiCallWithHeader(
                        "/User/getOneUser"
                    )
                }
            }
            if (userDetail && userDetail.data && userDetail.data.userData) {
                this.userId = userDetail.data.userData._id
            }
            if (this.userId) {
                this.$store.dispatch("fairplaySockets/joinNotificationRoom", {
                    userId: this.userId,
                    socket1Id: socket1.id
                })
                // this.$store.dispatch('fairplaySockets/joinBonusRoom', {
                //   userId: this.userId,
                //   socket1Id: socket1.id
                // })
                // socket1.on(`userBonus-${this.userId}`, (data) => {
                // console.log('userBonus called from headers 2 ')
                // this.$store.dispatch('profile/getProfileForBonusSocket')
                // this.callProfileSocket()
                // })
                // socket1.on(`userBonus-${this.userId}`, (data) => {
                //   console.log('userBonus called from headers 2 ')
                //   this.$store.dispatch('profile/getProfileForBonusSocket')
                // })

                socket1.on(`sendNotificationToUser-${this.userId}`, (data) => {
                    this.$store.dispatch("profile/getNotifications")
                })
                // this.$store.dispatch("profile/getNotifications")
            }
        },
        async saveQuizAnswers(savedUserData) {
            const dataToSend = {
                userId: savedUserData._id,
                predictions: this.predictions
            }
            const res = await this.$store.dispatch(
                "contest/saveUserPredictions",
                dataToSend
            )
            if (
                res &&
                res.status === 200 &&
                res.data === "Contest Answers Saved Successfully."
            ) {
                this.$router.push("/thank-you")
            } else if (
                res &&
                res.status === 200 &&
                res.data === "Already answered"
            ) {
                this.showSnackbar({
                    content: "Predictions already saved",
                    color: "info"
                })
                this.$router.push("/")
            } else {
                this.showSnackbar({
                    content:
                        "No Internet Connection, while saving predictions try again",
                    color: "error"
                })
                this.$router.push("/")
            }
        },
        onError(error) {
            // console.log('Error happened:', error)
        },
        onSuccess(token) {
            // console.log('Succeeded:', token)
        },
        onExpired() {
            if (process.client) {
                window.location.reload()
            }
        },
        listenToAllSocket() {
            const userId = this.$auth.user._id
            const accessToken = this.$auth.getToken("customLocal")
            socket.commonSocket.on("AllSocket_" + userId, async (eventKeys) => {
                accessToken = this.$auth.getToken("customLocal")
                userId = this.$auth.user._id
                if (
                    eventKeys.eventKey === "Balance_" + userId ||
                    eventKeys.eventKey === "balanceWithData_" + userId ||
                    eventKeys.eventKey === "winnerDeclared-fancy-" + userId
                ) {
                    setTimeout(() => {
                        this.$store.dispatch("userBalance/getCurrentBalance")
                    }, 100)
                } else if (
                    eventKeys.eventKey ===
                    "logout_" + accessToken + "_" + userId
                ) {
                    this.$store.dispatch("user/logout")
                    this.$store.commit("snackbar/open", {
                        text: "Your session has ended, please login.",
                        color: "error"
                    })
                } else if (eventKeys.eventKey === "Rt_Invalidation_" + userId) {
                    this.$store.commit("snackbar/open", {
                        text: eventKeys.message,
                        color: "error"
                    })
                    const betId = await this.getBetradarID(this.markets)
                    await this.$store.dispatch("betBooks/getAllPremium", {
                        dataSet: betId,
                        refresh: true
                    })
                    this.$store.dispatch(
                        "openBets/getMyCurrentBetStatus",
                        false
                    )
                    this.$store.dispatch(
                        "openBets/getMyCurrentPremiumBet",
                        false
                    )
                    this.$store.dispatch(
                        "openBets/getMyCurrentPremiumRawBet",
                        false
                    )
                } else if (eventKeys.eventKey === "BetCancelled_" + userId) {
                    this.$store.commit("snackbar/open", {
                        text: eventKeys.message,
                        color: "error"
                    })
                    this.$store.dispatch(
                        "openBets/getMyCurrentBetStatus",
                        false
                    )
                    this.$store.dispatch(
                        "openBets/getMyCurrentPremiumBet",
                        false
                    )
                    this.$store.dispatch(
                        "openBets/getMyCurrentPremiumRawBet",
                        false
                    )
                    this.$store.dispatch(
                        "openBets/getMyCurrentBetStatusBookmakerMarket",
                        false
                    )
                }
            })
        },
        listenToBookSocket() {
            try {
                console.log(
                    "0. BookSocket_",
                    this.$auth.loggedIn,
                    this.matchIds
                )
                socket.commonSocket.on(
                    "BookSocket_" + this.$auth.user._id,
                    (eventKeys) => {
                        console.log(
                            "1. eventKeys",
                            eventKeys,
                            this.$auth.user._id,
                            this.matchIds
                        )
                        console.log("BOOK SOCKET CALLED START")
                        const matchIdsEventKeyFormat = this.matchIds.map(
                            (item) => "Book_" + item + "_" + this.$auth.user._id
                        )
                        if (
                            matchIdsEventKeyFormat.includes(eventKeys.eventKey)
                        ) {
                            console.log(
                                "2. inside if BookSocket_" +
                                    this.$auth.user._id +
                                    " inside if condition",
                                this.$route.name
                            )
                            let booksCall = "betBooks/getAll"
                            if (
                                this.$route.name ===
                                    "sportsbook-category-subCategory-id" ||
                                this.$route.name ===
                                    "sportsbook-category-subCategory-id-betradar"
                            ) {
                                console.log("3. inside if route")
                                booksCall = "betBooks/get"
                            }
                            console.log(
                                "4. matchIds",
                                this.matchIds,
                                booksCall,
                                this.refresh
                            )
                            // setTimeout(() => {
                            this.$store.dispatch(
                                booksCall,
                                this.matchIds,
                                this.refresh === false
                            )
                            // }, 300)
                            console.log("BOOK SOCKET CALLED END")
                        }
                    }
                )
            } catch (error) {
                console.log("X. socket BookSocket_ catch", error)
            }
        },
        showEdgeLight() {
            if (process.client) {
                const edgeLight = document.querySelector(".edge-light")

                if (!edgeLight) {
                    console.warn("Edge light element not found!")
                    return
                }

                if (this.edgeLightTimeout) {
                    clearTimeout(this.edgeLightTimeout)
                }

                edgeLight.classList.add("visible")

                this.edgeLightTimeout = setTimeout(() => {
                    edgeLight.classList.remove("visible")
                }, 1500)
            }
        }
    }
}
</script>

<style lang="scss">
.header-section {
    z-index: 1;

    .v-toolbar__extension {
        // padding: 0 !important;
        z-index: -1;
    }
    .menu-tabs {
        margin-right: -16px;
    }

    .v-tabs--icons-and-text > .v-tabs-bar .v-tab > *:first-child {
        margin-bottom: 0px !important;
    }

    .cursor-pointer,
    .cursor-pointer-fps {
        margin-bottom: 20px;
    }
}

.v-text-field.v-text-field--solo .v-input__control {
    min-height: 35px;
    padding: 10px;
}

.input-width {
    width: 180px;

    .v-input__control {
        .v-input__slot {
            padding-bottom: 4px !important;
        }
    }
}

.header-margin {
    margin-right: 16px;
    background: linear-gradient(to bottom, #000000 0%, #000000 100%);
    //box-shadow: 0px 28px 20px -10px #e80a0afa inset !important;
}

.header-top {
    .div-tilt:before {
        //box-shadow: 0px 28px 20px -10px #000000 inset;
        background: linear-gradient(to bottom, #000000 0%, #000000 100%);
    }
}

// .primary--border {
//     border-radius: 25px;
// }
.menu-nav {
    .v-tab {
        position: relative;
        border: 0.09rem solid transparent;
        transform: scale(1);

        &.v-tab--active {
            border: 0.09rem solid transparent;
            // border: 0.09rem solid rgb(250, 123, 4);
            // border-radius: 30px;
            // font-weight: bolder;
            // color: rgb(250, 123, 4) !important;
            color: var(--v-orangemid-base) !important;
            border-radius: 100px;
            transform: scale(1.05);
            font-weight: bold;
            border-collapse: collapse;
            box-shadow: 0px 8px 26px -23px rgba(255, 255, 255, 0.75) inset;
            -webkit-box-shadow: 0px 8px 26px -23px rgba(255, 255, 255, 0.75) inset;
            -moz-box-shadow: 0px 8px 26px -23px rgba(255, 255, 255, 0.75) inset;
            -webkit-transition: 0.6s;
            -webkit-transform-style: preserve-3d;

            -moz-transition: 0.6s;
            -moz-transform-style: preserve-3d;

            -o-transition: 0.6s;
            -o-transform-style: preserve-3d;

            transition: 0.6s;
            transform-style: preserve-3d;

            position: relative;

            // padding-right: 12px !important;
            // .v-image__image--contain {
            //   animation: spinShadow 2s forwards;
            // }
            &:before {
                content: "";
                position: absolute;
                height: auto;
                width: 100%;
                left: 0;
                border-radius: 100px;
                // border: 0.09rem solid #fa7b04;
                border-color: var(--v-orangemid-base);
                box-shadow: var(--v-orangemid-base);
                // animation: spinShadow 2s infinite;
                opacity: 0.5 !important;
            }
        }

        @keyframes spinShadow {
            to {
                transform: rotate(360deg);
            }
        }

        &:hover {
            // transform: scale(1.05);
            // transition: transform 250ms linear;
            // font-weight: bold;
            color: var(--v-orangemid-base) !important;
            border-radius: 100px;
            border-collapse: collapse;
            box-shadow: 0px 8px 26px -23px rgba(255, 255, 255, 0.75) inset;
            -webkit-box-shadow: 0px 8px 26px -23px rgba(255, 255, 255, 0.75) inset;
            -moz-box-shadow: 0px 8px 26px -23px rgba(255, 255, 255, 0.75) inset;

            // .v-image {
            //   animation: spinShadow 2s forwards;
            //   -webkit-transform: rotateY(180deg);
            //   -moz-transform: rotateY(180deg);
            //   -o-transform: rotateY(180deg);
            //   transform: rotateY(180deg);
            // }
            &:before {
                content: "";
                position: absolute;
                height: auto;
                width: 100%;
                left: 0;
                border-radius: 100px;
                box-shadow: var(--v-orangemid-base);
                // border: 0.09rem solid #fa7b04;
                border-color: var(--v-orangemid-base);
                opacity: 0.5 !important;
            }
        }

        &:hover,
        &:focus,
        &:before {
            background: none;
            border: 0.09rem solid transparent;
        }
    }

    // .v-tab:hover::before,
    // .v-tab:focus::before {
    //   // opacity: 0 !important;
    //   content: '';
    //   border: 0.09rem solid rgb(250, 123, 4);
    //   border-radius: 30px;
    // }
}
.v-tabs--icons-and-text > .v-tabs-bar .v-tab {
    flex-direction: column !important;
    display: flex;
    border-right: 1px solid #6e6e6e;
}

.menu-tab {
    &.tab-below {
        z-index: 99;
        position: fixed;
        bottom: 0;
        margin-top: 1rem;
        @media only screen and (max-width: 1023px) {
            bottom: -1px;
        }
        a.v-tab {
            display: flex;
            flex-direction: column !important;
            @media only screen and (max-width: 540px) {
                position: relative;
                padding: 0 0.5rem;
                min-width: 75px !important;
            }
            @media only screen and (max-width: 420px) {
                // font-size: 0.6rem !important;
                // padding: 0 0.2rem;
                // min-width: 65px !important;
                font-size: 0.7rem !important;
                padding: 0 0.2rem;
                min-width: 70px !important;
            }
            @media only screen and (max-width: 375px) {
                // font-size: 0.6rem !important;
                // padding: 0 0.2rem;
                // min-width: 55px !important;
                font-size: 0.6rem !important;
                padding: 0 0.2rem;
                min-width: 68px !important;
            }
            @media only screen and (max-width: 320px) {
                font-size: 0.51rem !important;
                padding: 0 0.2rem;
                min-width: 45px !important;
            }
            animation: slideUp 0.6s linear;
        }
    }
    .v-item-group {
        background: linear-gradient(
            to top,
            rgba(10, 10, 10, 50%) 50%,
            rgb(50 50 50) 100%
        );
        border-bottom: 1px solid #333;
        border-top: 1px solid #4c4c4c;
    }
    .v-tabs-slider-wrapper {
        display: none !important;
    }
}
.mobile-menu-blocks.v-tab {
    border-right: 0 !important;
    padding-left: 10px !important;
    @media only screen and (max-width: 320px) {
        padding-left: 0px !important;
        margin-right: -10px !important;
    }
    @media only screen and (max-width: 320px) {
        span {
            font-size: 0.6rem !important;
        }
    }
}
.v-tabs-slider.red {
    width: 60%;
    margin: 0 auto;
    margin-bottom: 2rem;
}
.more {
    margin: 0 !important;
    padding: 0.2rem 0;
    width: 1.5rem;
    // height: 1.4rem;
    max-width: 100%;
    // filter: brightness(0) invert(1);
    @media only screen and (max-width: 912px) {
        width: 1.1rem;
    }
}

.menu-list {
    padding: 0px 12px;
}

.f-10 {
    font-size: 10px;
}

.search-width {
    max-width: 200px;
}

.maintenanceModal {
    white-space: normal;
    word-break: keep-all;
    font-size: 14px !important;
}

.search-one {
    margin-right: 4px !important;
}

.deposit_text {
    display: none;
}

.v-tabs--icons-and-text > .v-tabs-bar .v-tab {
    flex-direction: column;
    display: flex;
}

@media (min-width: 1900px) and (max-width: 2560px) {
    .menu-list {
        padding: 0px 300px !important;
    }
}

@media screen and (min-width: 1279px) and (max-width: 1300px) {
    .hide-search {
        display: none;
    }
}

@media (min-width: 960px) and (max-width: 1075px) {
    // .pre_logo {
    //   width: 70px !important;
    // }
    .login-btn,
    .loginBtn {
        padding: 0 9px !important;
    }
}

@media (max-width: 768px) {
    .pre_logo {
        width: 80px !important;
    }

    .header-section {
        .cursor-pointer,
        .cursor-pointer-fps {
            margin-bottom: 8px !important;
        }

        // .v-tabs--icons-and-text > .v-tabs-bar .v-tab {
        //     flex-direction: column-reverse;
        // }
        // .v-tabs--icons-and-text > .v-tabs-bar .v-tab > *:first-child {
        //     margin-bottom: 6px !important;
        // }
    }

    .v-tabs--icons-and-text > .v-tabs-bar .mobile-menu-blocks,
    .set-reverse {
        flex-direction: column !important;
    }
}

@media (min-width: 767px) and (max-width: 960px) {
    .pre_logo {
        width: 80px !important;
    }

    .header-section {
        .cursor-pointer,
        .cursor-pointer-fps {
            margin-bottom: 8px !important;
        }

        // .v-tabs--icons-and-text > .v-tabs-bar .v-tab {
        //     flex-direction: column-reverse;
        // }
        // .v-tabs--icons-and-text > .v-tabs-bar .v-tab > *:first-child {
        //     margin-bottom: 6px !important;
        // }
    }
}

@media (max-width: 360px) {
    .header-section {
        .v-btn:not(.v-btn--round).v-size--small {
            min-width: 30px !important;
            padding: 0 10.444444px;
        }
    }
}

@media (min-width: 334px) and (max-width: 700px) {
    .deposite_icon {
        display: none;
    }

    .deposit_text {
        display: block;
    }

    .deposit_now_text {
        display: none;
    }
}

@media (max-width: 320px) {
    .login-btn {
        top: 8px;
        padding: 0 11px !important;
    }

    .before-loggin {
        width: 56%;
        padding-bottom: 12px;
    }

    .before-loggin-fps {
        width: 38%;

        // padding-bottom: 12px;
        .login-form {
            place-content: end;
        }
    }

    .login-form {
        place-content: end;
    }

    .header-section {
        .cursor-pointer {
            margin-bottom: 8px !important;
        }

        .cursor-pointer-fps {
            margin-bottom: 0 !important;
        }
    }

    .header-margin {
        margin-right: 0px !important;
        // box-shadow: 0px 28px 20px -10px #e80a0afa inset;
    }
}

@media screen and (min-width: 300px) and (max-width: 376px) {
    .hide-search {
        display: none;
    }
}

@media screen and (min-width: 250px) and (max-width: 300px) {
    .user-balance {
        display: none;
    }
}

.error_message {
    .v-messages {
        font-size: 11px;
    }
}

.v-messages__message {
    line-height: 10px;
}
.left-main,
.left-main-category {
    .v-slide-group__content {
        @media only screen and (max-width: 460px) {
            overflow-x: scroll;
            width: 200px;
        }
    }
}
</style>
